// used and adjusted functionality from markets-switcher.js
class DomainForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        switcher: this.querySelector('.market_switcher_wrapper')
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.elements.switcher.addEventListener('focusout', this.closeSelector.bind(this));
    }
  
    onItemClick(event) {
      event.preventDefault();
      window.location.href = event.currentTarget.dataset.value;
   
    }
  
    hidePanel() {
      this.elements.switcher.removeAttribute('open');
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'SUMMARY';
      console.log(shouldClose, event.relatedTarget);
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  
  }
  
  customElements.define('domain-form', DomainForm);